/**
 * This is the image Lazy-loader service
 */

const $request = [ function () {
    let match,
        pl = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
            return decodeURIComponent(s.replace(pl, " "));
        },
        query = window.location.search.substring(1);
    let params = {};
    while ( match = search.exec(query)) {
        params[decode(match[1])] = decode(match[2]);
    }
    return {
        host: window.location.hostname,
        path: window.location.pathname,
        query: params,
        /**
         * @param o
         * @returns {string}
         */
        http_build_query: function (o) {
            let s = [];
            for ( let p in o ) if ( o.hasOwnProperty(p)) {
                s.push(encodeURIComponent(p) + "=" + encodeURIComponent(o[p]));
            }
            return s.join("&");
        },
    }
}];

export default $request;
